import { Close } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, Modal, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMessage } from '../../../../base/MessageProvider';
import { useDispatch, useSelector } from 'react-redux';
import { MuiOtpInput } from 'mui-one-time-password-input';
import Timer from '../../../../components/Timer';
import clsx from 'clsx';
import { Bars } from 'react-loader-spinner';
import { otpLogin, verifyLoginOtp, verifySignupOtp } from '../../../actions/auth';

const boxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    width: '90%',
    bgcolor: 'white',
    paddingX: 5,
    paddingY: 3,
    borderRadius: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' 
}

const CustomBorderTextField = styled(MuiOtpInput)`
    & .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
            border-color: #3A3A3A;
        }
    }
`;

const OtpModal = ({ open, onClose, isLogin }) => {
    const [otp, setOtp] = useState('');
    const [resendState, setResendState] = useState(false);
    const [resetTimer, setResetTimer] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const loading = useSelector((state) => state.artistAuthReducer?.loading);
    const requiredOtp = useSelector((state) => state.artistAuthReducer?.verificationOtp);
    const userId = useSelector((state) => state.artistAuthReducer?.userId);
    const mobileNo = useSelector((state) => state.artistAuthReducer?.mobileNo);

    const navigate = useNavigate();
    const alert = useMessage();
    const dispatch = useDispatch();

    useEffect(() => {
        setResendState(false);
        console.log(requiredOtp)
        setErrorMessage("");
        if (requiredOtp) {
            // alert.showInfo(`OTP ${requiredOtp}`, { timeout: 5000 });
        } else {
            navigate('/artist/auth', { replace: true });
        }
    }, [])

    const handleChange = (newValue) => {
        setOtp(newValue)
    }

    const validateChar = (value, index) => {
        const isNumber = typeof value === 'number';
        const isString = typeof value === 'string';
        return (isNumber || (isString && value !== '')) && !isNaN(Number(value));
    }

    const handleResendOtp = async () => {
        if (!resendState) return;
        dispatch(otpLogin({ mobileNo }, (loginOtp) => {
            alert.showInfo(loginOtp, {
                timeout: 5000
            });
            setResendState(false);
            setResetTimer(prev => !prev);
        }, (error) => {
            setErrorMessage(error?.message ?? "Something went wrong!!");
        }));
    }

    const handleTimeUp = () => {
        // handle time up here
        setResendState(true);
    };

    const handleLoginSubmit = async () => {
        setErrorMessage("");
        dispatch(verifyLoginOtp({ userId, otp: otp }, () => {
            navigate('/artist', { replace: true });
        }, (res) => {
            if (res?.metadata?.signupToken) navigate('/artist/auth/basic-info', { replace: true });
            else {
                setErrorMessage(res?.message ?? "Something went wrong!!");
            }
        }, (error) => {
            setErrorMessage(error?.message);
        }))
    }

    const handleSignupSubmit = async () => {
        setErrorMessage("");
        dispatch(verifySignupOtp({ userId, otp: otp }, () => {
            navigate('/artist/auth/basic-info', { replace: true });
        }, (error) => {
            setErrorMessage(error?.message);
        }))
    }

    const onSubmit = async (e) => {
        e?.preventDefault?.();
        if (isLogin) handleLoginSubmit();
        else handleSignupSubmit();
    }

    const DISABLED = loading || otp?.length !== 5; 

    return (
        <Modal disableAutoFocus sx={{ bgcolor: '#F4F4F499'}} hideBackdrop open={open}>
            <form onSubmit={onSubmit} action="#">
                <Box className="shadow-[0_0_14px_grey]" sx={boxStyle}>
                    <IconButton onClick={onClose} className='absolute top-3 right-3' size='small'> 
                        <Close className='text-xl' />
                    </IconButton>
                    <Box className="mb-6">
                        <h2 className="font-['Poppins-Medium'] font-[500] text-[16px]">ENTER OTP</h2>
                    </Box>
                    <div className="flex flex-col gap-3">
                        <span className="text-[12px] text-[#6D7175] font-['CG-Regular'] text-center">Enter Received Otp</span>
                        <CustomBorderTextField
                            length={5} value={otp} onChange={handleChange} 
                            validateChar={validateChar} 
                            autoFocus
                            TextFieldsProps={{ size: 'small', InputProps: { className: 'rounded-full h-[50px] w-[50px]' } }}
                            // TextFieldsProps={{ disabled: loading }}
                        />
                    </div>
                    {errorMessage && (
                        <div className="flex mt-2 w-full">
                            <div className="text-[12px] text-red-600">{errorMessage}</div>
                        </div>
                    )}
                    <div className="w-full flex gap-1 justify-end items-center mt-2 mb-3">
                        <Timer
                            key={`key-${resetTimer}`}
                            duration={300}
                            timeUpCallback={handleTimeUp}
                            className="text-[13px] font-['CG-Medium'] text-[#000]"
                        />
                        <span onClick={handleResendOtp} className={clsx("text-[13px] font-['CG-Medium'] cursor-pointer ", { "text-[#2F80ED] hover:underline active:text-gray-400": resendState, "text-[#2F80EDa1]": !resendState})}>RESEND OTP</span>
                    </div>
                    <Button onClick={onSubmit} disabled={DISABLED} className={clsx("bg-[#2F80ED] flex gap-3 justify-center text-[#FFF] w-full rounded-full my-3 font-['Poppins-Medium'] font-[500]", { "bg-opacity-70": DISABLED })}>
                        {isLogin ? "Log In" : "Sign Up"}
                        <Bars
                            height="20"
                            width={'20'}
                            color="#FFFFFF"
                            ariaLabel="bars-loading"
                            visible={loading}
                        />
                    </Button>
                    {/* <p className="font-['Matter-Regular'] font-[400] text-[12px] text-center text-[#1F1E1E]">
                        Don't Have An Account? <a onClick={onClickSignup} className="text-[#2F80ED] hover:underline cursor-pointer">Sign Up</a>
                    </p> */}
                </Box>
            </form>
        </Modal>
    );
}

export default React.memo(OtpModal, (prevProps, nextProps) => {
    return prevProps.open === nextProps.open
});